import type { TooltipTriggerComponentProps } from 'react-aria-components'
import { TooltipTrigger as AriaTooltipTrigger } from 'react-aria-components'

export default function TooltipTrigger(props: TooltipTriggerComponentProps) {
  return (
    <AriaTooltipTrigger
      {...{
        delay: 100,
        closeDelay: 300,
        ...props,
      }}
    />
  )
}
